import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const displayPrice = product.salePrice || product.price;
  const isOutOfStock = product.stock === 0;

  return (
    <div className="product-card">
      <Link to={`/product/${product._id}`}>
        <div className="product-card__image-wrap">
          <img
            src={product.images[0] || 'https://via.placeholder.com/400x530?text=Stonari'}
            alt={product.name}
            className="img-main"
          />
          <div className="product-card__badges">
            {product.isOnSale && !isOutOfStock && <span className="badge badge-sale">Sale</span>}
            {isOutOfStock && <span className="badge badge-out">Out of Stock</span>}
          </div>
          <div className="product-card__hover-btn">
            <span>View Product</span>
          </div>
        </div>
        <div className="product-card__info">
          <h3 className="product-card__name">{product.name}</h3>
          <div className="product-card__price">
            <span className="sale">₹{displayPrice.toFixed(0)}</span>
            {product.isOnSale && (
              <span className="original">₹{product.price.toFixed(0)}</span>
            )}
          </div>
        </div>
      </Link>
      <div className="product-card__actions">
        <button
          className="btn btn-outline btn-full btn-sm"
          onClick={() => !isOutOfStock && addToCart(product._id, 1)}
          disabled={isOutOfStock}
        >
          {isOutOfStock ? 'Out of Stock' : 'Add to Cart'}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
